function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import GridImage from "segments/desktop/core-components/grid-image/grid-image";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { StyledCardsGridMobileComponent } from "./cards-grid-mobile-component.scss";
import cardsGridDefaultProps from "../default-props";
const IMAGE_HEIGHT = "85px";
const IMAGE_WIDTH = "85px";
class CardsGridMobileComponent extends PureComponent {
    renderGridItems() {
        const { gridItems } = this.props;
        return gridItems.map((gridItem, index)=>{
            const { fullParagraph = {} } = gridItem, resImageProps = _object_without_properties(gridItem, [
                "fullParagraph"
            ]);
            const { title, buttonConfig } = fullParagraph;
            return /*#__PURE__*/ _jsx("div", {
                className: "grid-image-with-paragraph-component-wrapper",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "inner-frame",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "grid-image-wrapper",
                            children: /*#__PURE__*/ _jsx(GridImage, _object_spread_props(_object_spread({}, resImageProps), {
                                width: IMAGE_WIDTH,
                                height: IMAGE_HEIGHT
                            }))
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "mobile-paragraph-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "title-wrapper",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "title",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "button-wrapper",
                                    children: /*#__PURE__*/ _jsx(SecondaryButton, _object_spread({}, buttonConfig))
                                })
                            ]
                        })
                    ]
                })
            }, index);
        });
    }
    render() {
        return /*#__PURE__*/ _jsx(StyledCardsGridMobileComponent, {
            className: "cards-grid-mobile-component",
            children: this.renderGridItems()
        });
    }
}
export { CardsGridMobileComponent as default };
CardsGridMobileComponent.defaultProps = cardsGridDefaultProps;
